import * as UI from "@accurx/design";
import { Log } from "@accurx/shared";

export const Reload = () => {
    Log.error("Unexpectedly escaped the inbox");
    window.location.reload();
    return <UI.Spinner />;
};
